import Model from './Model'

export default class CommentReport extends Model {
  resource() {
    return 'report'
  }
}
